var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86555 15.9916C13.2778 15.5661 15.9182 12.6553 15.9182 9.12782C15.9182 5.3075 12.8212 2.21052 9.00088 2.21052C5.18055 2.21052 2.08357 5.3075 2.08357 9.12782C2.08357 12.6553 4.72398 15.5661 8.13622 15.9916V10.8571H6.40688V9.12782H8.13622V7.69749C8.13622 6.54123 8.25658 6.12193 8.48269 5.6992C8.70871 5.27648 9.04048 4.94472 9.46322 4.71865C9.79412 4.54169 10.2046 4.43488 10.9219 4.38907C11.2065 4.37089 11.5751 4.39408 12.0272 4.45864V6.1015H11.5949C10.8017 6.1015 10.4744 6.13896 10.2788 6.24359C10.1575 6.30849 10.0725 6.39339 10.0076 6.51475C9.90298 6.71038 9.86555 6.90437 9.86555 7.69749V9.12782H12.0272L11.5949 10.8571H9.86555V15.9916ZM9.00088 17.7744C4.22547 17.7744 0.354248 13.9032 0.354248 9.12782C0.354248 4.35242 4.22547 0.481201 9.00088 0.481201C13.7762 0.481201 17.6475 4.35242 17.6475 9.12782C17.6475 13.9032 13.7762 17.7744 9.00088 17.7744Z",
    fill: "#F2FF41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFacebook);
export default __webpack_public_path__ + "static/media/i-facebook.e55753f2ca278ef7812d081a62f54e28.svg";
export { ForwardRef as ReactComponent };